module.exports = __webpack_public_path__ + "media/assets/partners/5fpro-7bc589ab2f81d18170adc14432fb67f6.svg";